import { EFaceType } from '@/editor/entities/type';
import { globalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';
import { EParamGroupLabel, EParamLabel, EParamsKeys, EParamType, IEditParams } from '@/editor/types/editParamType';
import { isColumnFace, isWallFace } from '@/editor/utils/face';
import { IMaterialInfoData } from '@/pages/app/layout/tab-params/types';
import { ECommonUnit } from '@/types/enum';

export function getFaceParamInfo(faceId: string) {
  const faceData = globalStores.faceStore.getFaceData(faceId);
  if (!faceData) return;

  const { id } = faceData.materialInfo;
  const currentMaterialCfg =
    (faceData.type === EFaceType.RegionFace
      ? globalStores.materialStore.getFloorMaterial(id)
      : globalStores.materialStore.getFaceMaterial(id)) || globalStores.materialStore.getDefaultMaterial(faceData.type);

  if (!currentMaterialCfg) return;

  const title = isWallFace(faceData) || isColumnFace(faceData) ? EParamGroupLabel.FACE : EParamGroupLabel.FLOOR;

  const paramDatas: IEditParams = {
    id: faceData.id,
    type: EEntityType.Face,
    title,
    group: [
      ...[
        {
          id: title,
          label: title,
          fields: [EParamsKeys.material],
          hideLabel: true
        }
      ]
    ],
    values: {
      [EParamsKeys.material]: {
        thumbnail: currentMaterialCfg.display.thumbnail,
        price: currentMaterialCfg.properties.price,
        name: currentMaterialCfg.name,
        id: faceData.id,
        unit: ECommonUnit.yenPerSqm,
        type: EEntityType.Face
      } satisfies IMaterialInfoData
    },
    fields: {
      [EParamsKeys.material]: {
        type: EParamType.MATERIAL_INFO,
        label: EParamLabel.ROOM_TYPE,
        settings: {
          hideLabel: true,
          readonly: false
        }
      }
    }
  };

  return paramDatas;
}
